<template>
	<nav id="stl_menu" class="navbar navbar-dark navbar-expand">
		<ul class="navbar-nav mr-auto">
			<li id="view_menu" class="nav-item dropdown active">
				<a id="view_header" class="nav-link" tabindex="0" data-toggle="dropdown" data-submenu
					aria-expanded="false">View</a>
				<div id="viewSubMenu" class="dropdown-menu menu3d">
					<!-- <ShowHideMenu v-if="!isOnlyDicom" :bones="bones" :allTeeth="allTeeth" /> -->
					<!-- <OpacityMenu :bones="bones" :allTeeth="allTeeth" /> -->
					<ColorMenu v-if="!isOnlyDicom" :bones="bones" :allTeeth="allTeeth" />
					<OcclusalMenu v-if="!isOnlyDicom && !isNoTeeth" />
					<DicomMenu v-if="hasDicom" :isMobileDevice="isMobileDevice" :dicomLowLink="dicomLowLink"
						:dicomMiddleLink="dicomMiddleLink" :dicomHighLink="dicomHighLink" :isOnlyDicom="isOnlyDicom" />

					<AirwayMenu v-if="!isOnlyDicom && airways.length" />

					<IntraoralMenu v-if="!isOnlyDicom && isIntraoral" />
					<ToothOldNumberMenu v-if="!isOnlyDicom" :isEngineerMode="isEngineerMode" />
					<ToothNumberMenu v-if="!isOnlyDicom && !isNoTeeth && !isViewMode" />
					<ToothAddMenu v-if="!isOnlyDicom && !isNoTeeth && !isViewMode" />
					<ToothRemoveMenu v-if="!isOnlyDicom && !isNoTeeth && !isViewMode" />

					<SmoothMenu v-if="!isOnlyDicom" />
					<!-- <AnchorageMenu /> -->

				</div>
			</li>


			<!-- <ImplantsMenu :implants="implants" :crowns="crowns" /> -->

			<OrthoMenu :currentStages="currentStages" :treatmentStages="treatmentStages"
				:isIntraoralView="isIntraoralView" :isValidTreatment="isValidTreatment"
				:isOcclusionAvailable="isOcclusionAvailable" :hasReports="hasReports"/>

			<ShareMenu :shortLink="shortLink" :shareLink="shareLink" :readonlyLink="readonlyLink" />

			<img id="infoImg" src="images/info_icon_white.png" title="Help" v-on:click="showHelp()" />
		</ul>
	</nav>
</template>

<script>
import ShowHideMenu from "@/components/showHide/ShowHideMenu.vue";
import OpacityMenu from "@/components/opacity/OpacityMenu.vue";
import ColorMenu from "@/components/color/ColorMenu.vue";
import OcclusalMenu from "@/components/occlusal/OcclusalMenu.vue";
import DicomMenu from "@/components/dicom/controls/DicomMenu.vue";
import AirwayMenu from "@/components/airway/AirwayMenu.vue";
import AnchorageMenu from "@/components/anchorage/AnchorageMenu.vue";
import ToothNumberMenu from "@/components/tooth/number/ToothNumberMenu.vue";
import ToothOldNumberMenu from "@/components/tooth/number/ToothOldNumberMenu.vue";
import ToothAddMenu from "@/components/tooth/add/ToothAddMenu.vue";
import ToothRemoveMenu from "@/components/tooth/remove/ToothRemoveMenu.vue";
import SmoothMenu from "@/components/quality/SmoothMenu.vue";
import IntraoralMenu from "@/components/intraoral/IntraoralMenu.vue";

import ImplantsMenu from "@/components/implants/ImplantsMenu.vue";
import OrthoMenu from "@/components/ortho/OrthoMenu.vue";
import ShareMenu from "@/components/share/ShareMenu.vue";


import { updateZipsForSourceType } from "@/components/saveLoadData";
// import { saveTestCurveMesh } from "@/components/dicom/annotation";

import $ from "jquery";
import "bootstrap-submenu"; // https://vsn4ik.github.io/bootstrap-submenu/#html-examples

export default {
	name: "MainMenu",
	props: [
		"dentations",
		"bones",
		"nerves",
		"airways",
		"allTeeth",
		"isNoTeeth",
		"hasDicom",
		"implants",
		"crowns",
		"hasReports",
		"currentStages",
		"treatmentStages",
		"isValidTreatment",
		"shortLink",
		"shareLink",
		"readonlyLink",
		"isStitched",
		"isOcclusionAvailable",
		"isIntraoral",
		"isIntraoralView",
		"isEngineerMode",
		"isViewMode",
		"isHighQuality",
		"isDicomOpen",
		"dicomLowLink",
		"dicomMiddleLink",
		"dicomHighLink",
		"isMobileDevice",
		"isOnlyDicom"
	],
	components: {
		ShowHideMenu,
		OpacityMenu,
		ColorMenu,
		OcclusalMenu,
		DicomMenu,
		AirwayMenu,
		AnchorageMenu,
		ToothNumberMenu,
		ToothOldNumberMenu,
		ToothAddMenu,
		ToothRemoveMenu,
		SmoothMenu,
		IntraoralMenu,

		ImplantsMenu,
		OrthoMenu,
		ShareMenu
	},
	methods: {
		showHelp: function () {
			if (!vueApp.isExpired) {
				// saveTestCurveMesh();	
				gtag('event', 'Help');
				vueApp.showHelp();
			}
		}
	},
	mounted: function () {
		// mounted does not guarantee that all child components have also been mounted
		this.$nextTick(function () {
			// Code that will run only after the entire view has been rendered
			$("[data-submenu]").submenupicker();
		});
	}
};
</script>

<style>
#stl_menu {
	background-color: #4687fc;
	padding: 0;
	height: 35px;
	z-index: 1002;
}

#view_header {
	cursor: pointer;
}

.navbar {
	padding-left: 0;
	padding-right: 0;
	font-family: Montserrat, sans-serif;
	font-size: small;
}

.navbar-nav {
	display: table;
	width: 100%;
	margin: 0;
}

.navbar-nav>li {
	float: none;
	display: table-cell;
	text-align: center;
	vertical-align: middle;
	width: 33%;
}

.navbar-nav>li>a {
	border-right: 1px solid #8EB5FD;
	padding-top: 0px;
	padding-bottom: 0px;
	height: 35px;
	display: flex;
	justify-content: center;
	/* align horizontal */
	align-items: center;
	/* align vertical */
	line-height: normal;
}

.navbar-nav>li:last-child>a {
	border-right: 0;
}

.nav-link {
	outline: 0;
	cursor: default;
}

.dropdown-menu {
	background-color: #8EB5FD;
	border-radius: 0;
	color: #FFFFFF;
	padding: 0;
	margin: 0;
	width: 100%;
	min-width: 0;
	font-size: small;
	border-width: 0;
}

.dropdown-menu>.border-bottom-item:last-child {
	border-bottom: 0;
}

.dropright .dropdown-menu {
	margin: 0;
}

.dropleft .dropdown-menu {
	margin: 0;
}

.border-bottom-item {
	border-bottom: 1px solid #D9E6FE;
}

.secondary-menu {
	background-color: #68a7fd;
	/* #4687fc; */
}

.third-menu {
	background-color: #F7FAFF;
	color: #797979;
}

.dropdown-item {
	color: #FFFFFF;
	padding: .25rem .25rem;
	width: 100%;
	text-align: center;
	outline: 0;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}

.dropdown-item:focus {
	background-color: transparent;
	color: #FFFFFF;
	outline: 0;
}

.dropdown-item:hover {
	color: #FFFFFF;
	text-decoration: none;
	background-color: transparent;
}

.dropdown-item:disabled {
	color: #6c757d;
	text-decoration: none;
	background-color: transparent;
}

#infoImg {
	z-index: 999;
	height: 35px;
	cursor: pointer;
	border-right: 1px solid #8EB5FD;
	margin-right: 33px;
}
</style>